import {Component, OnInit} from '@angular/core';
import {MmLanguageApiService} from '../../services/language-api.service';
import {NzTreeNode} from 'ng-zorro-antd/tree'
// import { MenuItem } from '../../definition';
import {BehaviorSubject} from 'rxjs';
import {switchMap, map, tap, filter} from 'rxjs/operators';
import {NzModalService} from 'ng-zorro-antd/modal';
// import { MenuFormComponent } from '../menu-form/menu-form.component';
import {TranslateService} from '@ngx-translate/core';
import {mmMenuConstants} from 'mm-web-core/menu/menu-constants';
import * as download from 'downloadjs'
import {NzIconService} from "ng-zorro-antd/icon";
import {USER_ICON_LITERAL} from "../../../../shared/consts";
import {mmLanguageConstants} from "../../language-constants";

@Component({
  selector: 'mm-language-management',
  templateUrl: './language-management.component.html',
  styleUrls: ['./language-management.component.scss']
})
export class MmLanguageManagementComponent implements OnInit {

  constructor(private api: MmLanguageApiService,
              private modalService: NzModalService,
              private translateService: TranslateService,
              private iconService: NzIconService) {
  }

  async ngOnInit() {
    this.api.getTranslations().subscribe(data => {
    })
  }

  add() {
  }

  resolveKey(key: string) {
    return `${mmLanguageConstants.translationGroup}.${key}`;
  }
}